import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/forgot-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();
      
      if (response.ok) {
        setMessage(data.message + "\n\nPlease check your spam folder if you don't see the email.");
      } else {
        setError(data.error || 'Failed to send reset password email');
      }
    } catch (err) {
      setError('Something went wrong. Please try again.');
    }
  };

  return (
    <div style={{ 
      maxWidth: '400px', 
      margin: '40px auto',
      padding: '20px',
      fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      <h2 style={{
        fontSize: '28px',
        fontWeight: '600',
        color: '#2c3e50',
        marginBottom: '30px',
        textAlign: 'center'
      }}>Reset Password</h2>
      
      {message && (
        <div style={{ 
          color: '#16a34a',
          backgroundColor: '#f0fdf4',
          padding: '12px',
          borderRadius: '8px',
          marginBottom: '20px',
          textAlign: 'center',
          whiteSpace: 'pre-line'
        }}>
          {message}
        </div>
      )}
      
      {error && (
        <div style={{ 
          color: '#dc2626',
          backgroundColor: '#fef2f2',
          padding: '12px',
          borderRadius: '8px',
          marginBottom: '20px',
          textAlign: 'center'
        }}>
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <input 
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{ 
            width: '100%',
            padding: '12px 16px',
            marginBottom: '15px',
            borderRadius: '8px',
            border: '1px solid #cbd5e1',
            fontSize: '16px',
            transition: 'border-color 0.2s ease',
            boxSizing: 'border-box'
          }}
          required
        />
        
        <button 
          type="submit"
          style={{
            width: '100%',
            padding: '12px',
            backgroundColor: '#2980b9',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '16px',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            marginBottom: '15px'
          }}
        >
          Send Reset Link
        </button>
      </form>

      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <Link 
          to="/"
          style={{ 
            color: '#2980b9',
            textDecoration: 'none',
            fontSize: '14px'
          }}
        >
          Back to Login
        </Link>
      </div>
    </div>
  );
}

export default ForgotPassword; 